import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { COMMON_AGENT_FILTER_SEARCH_PARAMS } from "../../../agent/api";
import { DEFAULT_SPECIAL_COMMISSIONS_REPORT_QUERY_PARAMS } from "../api";
import { SpecialCommissionsReportFilterForm } from "../components/forms/SpecialCommissionsReportFilterForm";
import { SpecialCommissionsReportTable } from "../components/tables/SpecialCommissionsReportTable";
import { SpecialCommissionsReportFilterPageRequest } from "../types";

export const SpecialCommissionsReportContainer = () => {
  const searchParams = useFilterSearchParams<SpecialCommissionsReportFilterPageRequest>({
    params: [
      "periodStartDate",
      "periodEndDate",
      "scope",
      "specialCommissionKeyword",
      ...COMMON_AGENT_FILTER_SEARCH_PARAMS,
    ],
    defaultQueryParamsObject: DEFAULT_SPECIAL_COMMISSIONS_REPORT_QUERY_PARAMS,
  });

  return (
    <ContentWrapper>
      <SpecialCommissionsReportFilterForm searchParams={searchParams} />

      <SpecialCommissionsReportTable searchParams={searchParams} />
    </ContentWrapper>
  );
};
